import {call, put, select} from "redux-saga/effects";
import {API} from "../../backend/api";
import { GET_CONTRACTORS_REQUEST_SUCCESS, CREATE_CONTRACTOR_REQUEST_SUCCESS } from "./reducer";
import { State } from "../../interfaces/State";

export function* getContractors(action) {
    try {
        const state : State = yield select();
        const response = yield call(API.getContractors, state.app.token);

        yield put({
            type: GET_CONTRACTORS_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}



export function* createContractor(action) {
    try {
        const state : State = yield select();
        const response = yield call(API.createContractor, state.app.token, action.payload);

        yield put({
            type: CREATE_CONTRACTOR_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}